import {
  DiscountType,
  type HighlightedProductsEntity,
  type ProductEntity,
} from "@features/products/domain";
import type {
  ListHighlightedVariantsResponseModel,
  ProductVariantModel,
} from "../models/products.models";

export function mapHighlightedProducts(
  highlightedCategories: ListHighlightedVariantsResponseModel,
): HighlightedProductsEntity {
  const highlightProducts: Partial<HighlightedProductsEntity> = {};

  for (const [key, variants] of Object.entries(highlightedCategories)) {
    highlightProducts[key] = variants.map(mapProduct);
  }

  return highlightProducts as HighlightedProductsEntity;
}

export function mapProduct(variant: ProductVariantModel): ProductEntity {
  return {
    parentId: variant.productLegacyId || variant.productId,
    variantId: variant.variantLegacyId || variant.variantId,
    sku: variant.sku,
    name: variant.name,
    type: variant.type,
    thumbnail: variant.thumbnail,
    financials: {
      price: variant.financials.price,
      profit: variant.financials.profit,
      ...(variant.financials.discountType && {
        discount: {
          price: variant.financials.discountedPrice,
          type: variant.financials.discountType,
          ...(variant.financials.discountStartsAt && {
            startsAt: new Date(variant.financials.discountStartsAt),
          }),
          ...(variant.financials.discountExpiresAt && {
            expiresAt: new Date(variant.financials.discountExpiresAt),
          }),
        },
      }),
      finalPrice:
        variant.financials.discountType === DiscountType.SALE
          ? variant.financials.discountedPrice!
          : variant.financials.price,
    },
    orderTestingInfo: variant.orderTestingInfo,
    lockInfo: {
      isLocked: variant.lockInfo.isLocked,
      isOpenForTesting: variant.lockInfo.isOpenForTesting,
      quantity: variant.lockInfo.quantity,
      quantityUsed: variant.lockInfo.quantityUsed,
      ...(variant.lockInfo.expiresAt && {
        expiresAt: new Date(variant.lockInfo.expiresAt),
      }),
    },
    stockAvailability: variant.stockAvailability,
    isMultiVariant: variant.isMultiVariant,
    isPrimary: variant.isPrimary,
    isOnSale: variant.financials.discountType === DiscountType.SALE,
    hasSecondPlacementDiscount:
      variant.financials.discountType === DiscountType.SECOND_PLACEMENT,
    hasAdditionalQuantityDiscount:
      variant.financials.discountType === DiscountType.ADDITIONAL_QUANTITY,
  };
}
